export default {
    strings: {
        upload:                      'Nahrát',
        cancel:                      'Zrušit',
        back:                        'Zpět',
        closeModal:                  'Zavřít',
        uploadFailed:                'Nahrávání selhalo',
        failedToUpload:              'Nahrávání souboru %{file} selhalo',
        addMore:                     'Přidat další',
        addMoreFiles:                'Přidat více souborů',
        addingMoreFiles:             'Přidat více souborů',
        importFrom:                  'Nahrát z %{name}',
        dashboardWindowTitle:        'Uppy Dashboard Window (Stiskněte escape pro zavření)',
        dashboardTitle:              'Uppy Dashboard',
        copyLinkToClipboardSuccess:  'Odkaz zkopírován do schránky.',
        copyLinkToClipboardFallback: 'Copy the URL below',
        copyLink:                    'Zkopírovat odkaz',
        fileSource:                  'Zdroj souboru: %{name}',
        done:                        'Hotovo',
        removeFile:                  'Odstranit soubor',
        editFile:                    'Upravit soubor',
        editing:                     'Úprava %{file}',
        edit:                        'Upravit',
        finishEditingFile:           'Ukončit úpravy souboru',
        myDevice:                    'Moje zařízení',
        browse:                      'procházejte',
        dropPasteFiles:              'Přetáhněte soubory, vložte je, nebo %{browse}',
        dropPaste:                   'Přetáhněte soubory, vložte je, nebo %{browse}',
        dropPasteImportFiles:        'Přetáhněte soubory, vložte je, nebo %{browse}',
        browseFiles:                 'procházejte',
        uploadComplete:              'Nahrávaní dokončeno',
        resumeUpload:                'Obnovit nahrávání',
        pauseUpload:                 'Pozastavit nahrávání',
        retryUpload:                 'Zkusit znovu',
        retry:                       'Znovu',
        saveChanges:                 'Uložit změny',
        xFilesSelected:              {
            0: '%{smart_count} souborů vybráno',
            1: '%{smart_count} souborů vybráno'
        },
        uploading:                   'Nahrávám',
        complete:                    'Dokončeno',
        youCanOnlyUploadX:           {
            0: 'Můžete nahrát pouze %{smart_count} soubor',
            1: 'Můžete nahrát pouze %{smart_count} souborů'
        },
        youHaveToAtLeastSelectX:     {
            0: 'Musíte vybrat nejméně %{smart_count} soubor',
            1: 'Musíte vybrat nejméně %{smart_count} souborů'
        },
        uploadXFiles:                {
            0: 'Nahrát %{smart_count} soubor',
            1: 'Nahrát %{smart_count} souborů'
        },
        uploadXNewFiles:             {
            0: 'Nahrát +%{smart_count} soubor',
            1: 'Nahrát +%{smart_count} souborů'
        },
        xMoreFilesAdded:             {
            0: '%{smart_count} soubor přidán',
            1: '%{smart_count} soubor přidáno'
        },
        exceedsSize:                 'Maximální velikost souboru je',
        youCanOnlyUploadFileTypes:   'Můžete nahrát pouze:'
    },
}
